module.exports = __webpack_public_path__ + "static/img/raas_main_1.6cb298b.webp";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/raas_main_1.webp
// module id = UvoU
// module chunks = 0